// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".onboarding[data-v-07a0c4fc]{max-width:1024px!important;margin-left:auto!important;margin-right:auto!important}.onboarding-header[data-v-07a0c4fc]{margin-bottom:.5rem!important}@media (min-width:768px){.onboarding-header[data-v-07a0c4fc]{margin-bottom:1rem!important}}", ""]);
// Exports
module.exports = exports;
